import {
	DndContext,
	closestCenter,
	KeyboardSensor,
	useSensor,
	useSensors,
	TouchSensor,
	MouseSensor,
} from "@dnd-kit/core";
import Column from "src/components/kanban/Column";
import Container from "src/components/kanban/Container";
import Item from "src/components/kanban/Item";
import LoadMore from "src/components/kanban/LoadMore";
import useKanban, { ActiveDraggable } from "src/hooks/useKanban";

interface KanbanProps {
	children: any;
	onDrop: (params: ActiveDraggable) => void;
}

const Kanban = ({ children, onDrop }: KanbanProps) => {
	const sensors = useSensors(
		useSensor(MouseSensor, {
			// Require the mouse to move by 10 pixels before activating
			activationConstraint: {
				distance: 10,
			},
		}),
		useSensor(TouchSensor, {
			// Press delay of 250ms, with tolerance of 5px of movement
			activationConstraint: {
				delay: 0,
				tolerance: 5,
			},
		}),
		useSensor(KeyboardSensor)
	);
	const { current, actions } = useKanban();

	const handleDragStart = (event: any) => {
		actions.setActiveId(event?.active?.id);
	};

	const handleDragOver = (event: any) => {
		actions.setToColumn(event?.over?.id);
	};

	const handleDragEnd = () => {
		if (
			current?.id &&
			current?.from &&
			current.to &&
			current.from !== current.to
		) {
			onDrop(current);
		}
		actions.setActiveId(undefined);
		actions.setGhost({
			width: undefined,
			height: undefined,
		});
	};

	return (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragEnd={handleDragEnd}
			onDragStart={handleDragStart}
			onDragOver={handleDragOver}
		>
			<div className="flex flex-1 gap-4">{children}</div>
		</DndContext>
	);
};

Kanban.Item = Item;
Kanban.Column = Column;
Kanban.LoadMore = LoadMore;
Kanban.Container = Container;

export default Kanban;
